import { extensions } from '../../extensions/Extensions';
import { CanvasTilingSpritePipe } from './canvas/CanvasTilingSpritePipe';
import { TilingSpritePipe } from './TilingSpritePipe';

extensions.add(CanvasTilingSpritePipe);
extensions.add(TilingSpritePipe);
